import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon, CalendarIcon, ClipboardDocumentListIcon,
  BanknotesIcon, UserCircleIcon, XMarkIcon,
  HomeModernIcon, UserGroupIcon, ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { useSchoolBrand } from '../../hooks/useSchoolBrand';

const NAV = [
  { section:'Main',    name:'Dashboard',     href:'/hostel/dashboard',      icon:HomeIcon },
  { section:'Hostel',  name:'Rooms',         href:'/hostel/rooms',          icon:HomeModernIcon },
  { section:'Hostel',  name:'Allocation',    href:'/hostel/allocation',     icon:UserGroupIcon },
  { section:'Hostel',  name:'Fines',         href:'/hostel/fines',          icon:ExclamationTriangleIcon },
  { section:'Account', name:'My Attendance', href:'/hostel/own-attendance', icon:CalendarIcon },
  { section:'Account', name:'My Leaves',     href:'/hostel/own-leaves',     icon:ClipboardDocumentListIcon },
  { section:'Account', name:'My Salary',     href:'/hostel/salary',         icon:BanknotesIcon },
  { section:'Account', name:'Profile',       href:'/hostel/profile',        icon:UserCircleIcon },
];

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
  .hsb { width:240px; min-width:240px; min-height:100vh; background:#0f1123; display:flex; flex-direction:column; overflow-x:hidden; font-family:'Sora',sans-serif; border-right:1px solid rgba(255,255,255,.04); }
  .hsb-close { display:none; }
  @media(max-width:768px){
    .hsb-close { display:flex; align-items:center; justify-content:center; position:absolute; top:16px; right:16px; width:28px; height:28px; border-radius:8px; background:rgba(255,255,255,.08); border:none; cursor:pointer; }
    .hsb-close svg { width:15px; height:15px; stroke:white; stroke-width:2; }
    .hsb-brand { position:relative; }
  }
  .hsb-brand { padding:24px 20px 20px; border-bottom:1px solid rgba(255,255,255,.06); flex-shrink:0; }
  .hsb-brand-icon { width:34px; height:34px; background:#ec4899; border-radius:10px; display:flex; align-items:center; justify-content:center; margin-bottom:10px; }
  .hsb-brand-icon svg { width:18px; height:18px; fill:none; stroke:white; stroke-width:2; }
  .hsb-brand-name { font-size:.95rem; font-weight:700; color:#fff; letter-spacing:-.02em; line-height:1; }
  .hsb-brand-sub  { font-size:.68rem; color:#4a5075; margin-top:3px; letter-spacing:.04em; text-transform:uppercase; }
  .hsb-nav { flex:1; padding:12px; overflow-y:auto; overflow-x:hidden; scrollbar-width:none; }
  .hsb-nav::-webkit-scrollbar { display:none; }
  .hsb-section-label { font-size:.62rem; font-weight:600; color:#353b5c; text-transform:uppercase; letter-spacing:.08em; padding:16px 8px 6px; }
  .hsb-link { display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:10px; text-decoration:none; color:#7880a4; font-size:.82rem; font-weight:500; transition:background .15s,color .15s; margin-bottom:2px; position:relative; }
  .hsb-link-text { flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .hsb-link:hover { background:rgba(255,255,255,.04); color:#c8ccde; }
  .hsb-link.active { background:rgba(236,72,153,.12); color:#ec4899; }
  .hsb-link.active::before { content:''; position:absolute; left:-12px; top:25%; bottom:25%; width:3px; background:#ec4899; border-radius:0 3px 3px 0; }
  .hsb-link svg { width:17px; height:17px; stroke-width:1.7; flex-shrink:0; }
  .hsb-footer { padding:16px 12px; border-top:1px solid rgba(255,255,255,.05); flex-shrink:0; }
  .hsb-footer-text { font-size:.68rem; color:#353b5c; text-align:center; }
`;

const HostelSidebar = ({ onClose }) => {
  const location  = useLocation();
  const { brand } = useSchoolBrand();
  const sectionOrder = ['Main','Hostel','Account'];
  const sections = sectionOrder
    .map(sec => ({ sec, items: NAV.filter(n => n.section === sec) }))
    .filter(({ items }) => items.length > 0);

  return (
    <>
      <style>{style}</style>
      <div className="hsb">
        <div className="hsb-brand">
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
            {brand.logo
              ? <img src={brand.logo} alt="logo" style={{width:34,height:34,borderRadius:10,objectFit:'contain',background:'rgba(255,255,255,.95)',padding:2,border:'1px solid rgba(255,255,255,.12)',flexShrink:0}}/>
              : <div className="hsb-brand-icon">
                  <svg viewBox="0 0 24 24"><path d="M3 21V9l9-6 9 6v12M9 21v-6h6v6" /></svg>
                </div>
            }
            <div>
              <div className="hsb-brand-name">{brand.name || 'School Portal'}</div>
              <div className="hsb-brand-sub">Hostel Panel</div>
            </div>
          </div>
          {onClose && <button className="hsb-close" onClick={onClose}><XMarkIcon /></button>}
        </div>
        <nav className="hsb-nav">
          {sections.map(({ sec, items }) => (
            <div key={sec}>
              <div className="hsb-section-label">{sec}</div>
              {items.map(item => {
                const isActive = location.pathname.startsWith(item.href);
                return (
                  <Link key={item.name} to={item.href} className={`hsb-link${isActive ? ' active' : ''}`} onClick={onClose}>
                    <item.icon />
                    <span className="hsb-link-text">{item.name}</span>
                  </Link>
                );
              })}
            </div>
          ))}
        </nav>
        <div className="hsb-footer"><div className="hsb-footer-text">v1.0.0 · Hostel Portal</div></div>
      </div>
    </>
  );
};

export default HostelSidebar;
